<template>
  <div
    class="review-rating-wrapper"
    :class="{'margin-top-xxs': (!isSpacingExperimentEnabled && !hasReviews) || hasReviews}"
  >
    <Skeleton
      v-if="showSkeleton"
      height="20.5px"
      width="50%"
    />
    <template v-else>
      <div
        v-if="hasReviews"
        @click="reviewTopLinkTag()"
      >
        <ReviewTop
          v-if="isSpacingExperimentEnabled && hasReviews && isMcom"
          review-link="#review-section"
          :review-count="totalCount || 0"
          :rating="rating"
        />
        <Reviewlet
          v-if="isBcom || (!isSpacingExperimentEnabled && isMcom)"
          review-link="#review-section"
          :show-review-text="false"
          :review-count="totalCount || 0"
          :rating="rating"
        />
      </div>
      <Reviewlet
        v-else-if="!isInternationalMode && (isBcom || (!isSpacingExperimentEnabled && isMcom))"
        handle-no-ratings="writeReviewText"
        @writeAReview="handleWriteAReview"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Reviewlet from '@atomic-ui/reviewlet';
import ReviewTop from '@common-vue/media-card-large/src/components/experiments/ReviewTop';
import Skeleton from '@common-vue/atomic-ui/src/components/skeleton';
import { useBrand } from '@composables/useBrand';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useReviews } from '@composables/reviews/useReviews';
import { useReviewsRedirect } from '@composables/reviews/useReviewsRedirect';
import { useExperiments } from '@composables/useExperiments';
import { useReviewsStatistics } from '@composables/reviews/useReviewsStatistics';
import { useFeatureEligibility, useProductFlags } from '@modules/featureControl';
import { reviewTopLinkTag, writeReviewTopLinkTag } from '../features/analytics/reviews';

const { isMcom, isBcom } = useBrand();
const { isInternationalMode } = useFeatureEligibility();
const { reviewStatistics } = useCommonProductGetters();
const { isConsolidatedThirdVariantFlag } = useProductFlags();
const { averageRating, totalCount } = useReviewsStatistics();
const hasReviews = computed(() => (isConsolidatedThirdVariantFlag ? !!totalCount.value : reviewStatistics.value?.hasReviews));
const rating = computed(() => (isConsolidatedThirdVariantFlag ? averageRating.value : reviewStatistics.value?.rating));
const { loadingState, selectedFrequentlyMentioned } = useReviews();
const showSkeleton = computed(() => isConsolidatedThirdVariantFlag && loadingState.value === 'LOADING' && !selectedFrequentlyMentioned.value);

const { redirectToWriteReview, scrollToReviews } = useReviewsRedirect();
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();

const handleWriteAReview = () => {
  writeReviewTopLinkTag();
  if (isMcom) {
    redirectToWriteReview();
  } else {
    scrollToReviews();
  }
};
</script>
